<div class="container-fluid band p-3">
	<div class="container px-3">
		<h1 class="font-weight-bold">Profielpagina</h1>
	</div>
</div>

<section *ngIf="item == false" class="main p-3">
	<div class="container">
		<h2>403</h2>
		<p><a href="#">Ben je wel ingelogd?</a></p>
	</div>
</section>
<section *ngIf="item" class="main p-3">
	<div class="container">
		<nav class="pb-4 my-4">
			<a href="javascript:;" (click)="setTab('profile')" [ngClass]="currentTab == 'profile' ? 'active' : ''"
				class="btn btn-sm btn-secondary">Persoonlijke gegevens</a> &nbsp;
			<a href="javascript:;" *ngIf="item && item['isExternal'] == true" (click)="setTab('noPassword')"
				[ngClass]="currentTab == 'noPassword' ? 'active' : ''" class="btn btn-sm btn-secondary">Wachtwoord
				wijzigen</a> &nbsp;
			<a href="javascript:;" *ngIf="item && item['isExternal'] == false" (click)="setTab('security')"
				[ngClass]="currentTab == 'security' ? 'active' : ''" class="btn btn-sm btn-secondary">Wachtwoord
				wijzigen</a> &nbsp;

			<ng-container *ngIf="item.role !== 'TEACHER'">
			<a href="javascript:;" *ngIf="quizResults.length > 0" (click)="setTab('results')"
				[ngClass]="currentTab == 'results' ? 'active' : ''" class="btn btn-sm btn-secondary">Oefentoetsresultaten bekijken</a>
			&nbsp;
			<a href="javascript:;" 
				*ngIf="portfolioEnabled" 
				(click)="setTab('portfolio')" 
				[ngClass]="currentTab == 'portfolio' ? 'active' : ''"
				class="btn btn-sm btn-secondary btn-portfolio">
					Portfolio bekijken
					<span class="unread-feedback-count" *ngIf="unreadFeedbackCount && unreadFeedbackCount > 0">{{unreadFeedbackCount}}</span>
				</a>
			&nbsp;
			</ng-container>
		</nav>

		<h2 class="mb-3" *ngIf="currentTab=='profile'">
			<span routerLink="/" class="btn btn-secondary btn-sm mr-2"><i class="fas fa-arrow-left"></i></span>
			Persoonlijke gegevens
		</h2>
		<h2 class="mb-3" *ngIf="currentTab=='results'">
			<span routerLink="/" class="btn btn-secondary btn-sm mr-2"><i class="fas fa-arrow-left"></i></span>
			Oefentoetsresultaten bekijken
		</h2>
		<h2 class="mb-3" *ngIf="currentTab=='security'">
			<span routerLink="/" class="btn btn-secondary btn-sm mr-2"><i class="fas fa-arrow-left"></i></span>
			Wachtwoord wijzigen
		</h2>
		<h2 class="mb-3" *ngIf="currentTab=='portfolio'">
			<span routerLink="/" class="btn btn-secondary btn-sm mr-2"><i class="fas fa-arrow-left"></i></span>
			Portfolio bekijken
		</h2>

		<div class="row ml-0" (click)="closeDropdowns()">
			<div class="col-12 col-lg-12" *ngIf="currentTab=='portfolio'">
				<div class="row">
					<div class="col-3" id="portfolioNav">
						<div class="sticky">

							<div class="form-group filter-searchbar" *ngIf="item">
								<input type="text" class="form-control searchbar" [(ngModel)]="search" placeholder="Zoeken...">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
									<path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
								</svg>
							</div>

							<div class="filters-title mt-4">
								<h4>Filters</h4>
								<p class="clear-filters" (click)="clearFilters()">Filters wissen</p>
							</div>

							<hr class="filter-title-divider">

							<div class="mt-2">
								<div class="portfolioCol dropdown">
									<p class="mb-0">Klas</p>
									<i class="fas fa-chevron-up"></i>
								</div>

								<div>
									<div class="form-check" *ngFor="let classroom of portfolio.classrooms">
										<input (click)="toggleHiddenClassroom(classroom)"
											class="form-check-input" type="checkbox" value="" [id]="classroom">
										<label class="form-check-label" [for]="classroom">
											{{classroom}}
										</label>
									</div>
								</div>
							</div>

							<hr>

							<div class="mt-2">
								<div class="portfolioCol dropdown">
									<p class="mb-0">Vak</p>
									<i class="fas fa-chevron-up"></i>
								</div>

								<div>
									<div class="form-check" *ngFor="let section of portfolio.sections">
										<input (click)="toggleHiddenSection(section)" class="form-check-input"
											type="checkbox" value="" [id]="section">
										<label class="form-check-label" [for]="section">
											{{section}}
										</label>
									</div>
								</div>
							</div>

							<hr>

							<div class="mt-2">
								<div class="portfolioCol dropdown">
									<p class="mb-0">Module</p>
									<i class="fas fa-chevron-up"></i>
								</div>
								<div>
									<div class="form-check" *ngFor="let chapter of portfolio.chapters">
										<input (click)="toggleHiddenModule(chapter)" class="form-check-input"
											type="checkbox" value="" [id]="chapter">
										<label class="form-check-label" [for]="chapter">
											{{chapter}}
										</label>
									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="col-9">
						<div class="portfolioCol">
							<div class="form-group">
								<div class="select-wrapper">
									<span class="mr-3">Sorteren op:</span>
									<select (change)="sortEvent($event)" name="sort" class="form-control">
										<option value="true">
											Nieuwste
										</option>
										<option value="false">
											Oudste
										</option>
									</select>
								</div>
							</div>
							<div class="form-group">
								<button class="btn btn-success configure-portfolio" [class]="portfolio.loaded && portfolio.items.length === 0 ? 'no-portfolio' : ''" disabled (click)="openConfigurePortfolioModal()">
									<span>Portfolio samenstellen</span>
								</button>
							</div>
						</div>

						<div class="portfolioContent">
							<ng-container *ngIf="portfolio.loaded && portfolio.items.length > 0">
								<ng-container *ngFor="let item of portfolio.items">
									<div *ngIf="
										(selectedClassrooms.length < 1 || selectedClassrooms.includes(item.userClassroom)) && 
										(selectedModules.length < 1 || selectedModules.includes(item.chapterTitle)) && 
										(selectedSections.length < 1 || selectedSections.includes(item.sectionTitle)) && 
										canShowSearch(item.lessonTitle)"
										class="card mb-3" style="width: 32%;">
										<input class="portfolioCheck form-check-input" type="checkbox" [value]="item['id']" (change)="constructPortfolio()">
										<ng-container *ngIf="item.file">
											<img [src]="item.file" class="card-img-top" (click)="constructPortfolio(item['id'])">
										</ng-container>
										<ng-container *ngIf="!item.file">
											<div class="image-placeholder" (click)="constructPortfolio(item['id'])"></div>
										</ng-container>
										<div class="card-body">
											<div class="portfolio-card-block" (click)="constructPortfolio(item['id'])">
												<small class="sectiontitle">{{item.sectionTitle}}</small>
												<h5 class="card-title">
													{{item.lessonTitle}}<br>
													<small>{{chapterIdToName[item.chapterId]}}</small>
												</h5>
												<small class="chaptertitle">{{item.chapterTitle}}</small>
											</div>
											<div class="portfolio-card-block">
												<p class="sm mb-0">Laatst gewijzigd op:</p>
												<p class="last-changed-date">{{formatDate(item.updatedAt)}}</p>
												<hr>
												<div class="portfolioCol buttons">
													<a (click)="toggle(options)" class="share">
														<div class="icon">
															<i class="fas fa-share-nodes"></i>
														</div>
														Delen
														<ul class="dropdown-menu" #options>
															<li (click)="downloadPDF(item)"><a class="dropdown-item"><i class="fas fa-file-pdf"></i>
																	Opslaan als PDF</a></li>
															<li (click)="printPDF(item)"><a class="dropdown-item"><i class="fas fa-print"></i>
																	Afdrukken</a></li>
															<li>
																<hr class="dropdown-divider">
															</li>
															<li><a class="dropdown-item"><i class="fas fa-xmark"></i>
																	Sluiten</a></li>
														</ul>
													</a>
													<a (click)="viewPortfolioFeedback(item)"
													[ngClass]="{'has-unread-feedback-items' : item['unreadFeedbackCount'] > 0}"
													class="feedback">
														<div class="icon">
															<i class="fa-regular fa-comment-dots"></i>
														</div>
														Feedback <span class="unread-feedback-items" *ngIf="item['unreadFeedbackCount'] > 0">{{item['unreadFeedbackCount']}}</span>
													</a>
		
													<a class="modify" [ngClass]="!item['chapterLessonId'] ? 'disabled' : ''" routerLink="/les/{{item['chapterLessonId']}}" [queryParams]="{editportfolio: true}">
														<div class="icon">
															<i class="fa-solid fa-pencil"></i>
														</div>
														Wijzig</a>
													<a (click)="viewPortfolio(item['id'], item['lessonTitle'])" class="view">
														<div class="icon">
															<i class="fa-solid fa-eye"></i>
														</div>
														Bekijk</a>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</ng-container>
							<ng-container *ngIf="portfolio.loaded && portfolio.items.length === 0">
								<div class="card card-no-portfolio">
									<h2>Welkom bij je portfolio</h2>
									<p>De portfoliopagina toont al je portfoliostukken zodra je ze in de les hebt voltooid. Vanaf deze pagina kun je je portfolio bekijken, afdrukken en delen, je cijfers en opmerkingen bekijken en een verzameling maken van al je portfolio-werkstukken.</p>
								</div>
							</ng-container>
						</div>
					</div>
				</div>

				<hr class="mt-5 mb-5">

				<div class="row">
					<div class="col-3">
					</div>

					<div class="col-3">
						<h5>Privacy</h5>
						<p>Wil je weten hoe wij omgaan met je persoonlijke gegevens? <a
								href="https://uitgeverijneo.nl/blog/privacy-by-design-hoe-neo-omgaat-met-persoonsgegevens" target="_blank">Lees hierover op onze blog</a>.</p>
					</div>

					<div class="col-3">
						<h5>Account verwijderen</h5>
						<p>Alleen docenten kunnen accounts van leerlingen verwijderen.</p>
					</div>

					<div class="col-3">

						<h5>Wat is een goed wachtwoord?</h5>
						<p>Gebruik niet hetzelfde wachtwoord voor alles. Als een hacker jouw school e-mailadres hackt, wil je niet dat hij ook bij je privé e-mail of Netflix-account kan.</p>
					</div>
				</div>
			</div>

			<div class="col-12 col-lg-8" *ngIf="currentTab=='security'">
				<div class="alert alert-success" *ngIf="successmessage">Wijzigingen succesvol opgeslagen.</div>
				<div class="alert alert-danger" *ngIf="errormessage">Alle velden zijn verplicht om in te vullen.</div>

				<div class="form-group" *ngIf="item">
					<label for="adminpassword">Huidige wachtwoord ter controle</label>
					<input type="password" class="form-control" id="adminpassword" required
						[(ngModel)]="item['adminpassword']" (blur)="checkPassword($event.target.value)"
						(keyup)="checkPassword($event.target.value)"
						[ngClass]="{ 'is-invalid': (errorPassword ||  errors.adminpassword ), 'is-valid': passwordValid }"
						value="{{password}}" [(ngModel)]="password">
					<small class="form-text text-muted">Vul hier je eigen wachtwoord om misbruik te voorkomen.</small>
					<div class="error invalid-feedback" *ngIf="errors.adminpassword">{{errors.adminpassword}}</div>
				</div>
				<div class="form-group" *ngIf="item">
					<label for="newpassword">Nieuw wachtwoord</label>
					<input type="password" class="form-control" [ngClass]="{ 'is-invalid': errors.newpassword }"
						id="newpassword" required [(ngModel)]="item['newpassword']">
					<div class="error invalid-feedback" *ngIf="errors.newpassword">{{errors.newpassword}}</div>
				</div>
				<div class="form-group" *ngIf="item">
					<label for="repeatpassword">Herhaal wachtwoord</label>
					<input type="password" class="form-control" [ngClass]="{ 'is-invalid': errors.repeatpassword }"
						id="repeatpassword" required [(ngModel)]="item['repeatpassword']">
					<div class="error invalid-feedback" *ngIf="errors.repeatpassword">{{errors.repeatpassword}}</div>
				</div>

				<div class="form-group mt-5">
					<button (click)="save()" class="btn btn-success">
						<span>Wijzigingen opslaan</span>
					</button>
				</div>
			</div>

			<div class="col-12 col-lg-8" *ngIf="currentTab=='noPassword'">
				<div class="form-group">
					<p>Je hebt een Entree-account en dus geen wachtwoord bij {{SYSTEM_NAME}}</p>
				</div>
			</div>

			<div class="col-12 col-lg-8" *ngIf="currentTab=='profile'">
				<div class="alert alert-success" *ngIf="successmessage">Wijzigingen succesvol opgeslagen.</div>
				<div class="alert alert-danger" *ngIf="errormessage">Alle velden zijn verplicht om in te vullen.</div>

				<div class="form-group">
					<label for="email">E-mail</label>
					<input type="text" readonly *ngIf="item" class="form-control" value="{{item['email']}}" />
				</div>

				<div class="form-group">
					<label for="name">Naam</label>
					<input type="text" *ngIf="item" class="form-control" id="name" [(ngModel)]="item.name" name="name">
				</div>

				<div class="form-group" *ngIf="item['canSwitchStudyLevel'] != 1">
					<label>Niveau</label>
					<input type="text" readonly *ngIf="item" class="form-control" value="{{item['studyLevel']}}" />
				</div>

				<div class="form-group" *ngIf="item['canSwitchStudyLevel'] == 1">
					<label for="role">Niveau</label>
					<select name="role" [(ngModel)]="item['studyLevel']" class="form-control">
						<option value="{{studyLevel['value']}}" [selected]="item.studyLevel == studyLevel['key']"
							*ngFor="let studyLevel of studyLevels">
							{{studyLevel['name']}}
						</option>
					</select>
					<small class="text-muted">Deze optie is standaard niet beschikbaar voor leerlingen.</small>
				</div>

				<div class="form-group" *ngIf="item['role'] == 'STUDENT'">
					<label>Klas</label>
					<input type="text" readonly *ngIf="item" class="form-control" value="{{item['classrooms']}}" />
				</div>

				<div class="form-group">
					<label>School</label>
					<input type="text" readonly *ngIf="item" class="form-control"
						value="{{item['organisationName']}}" />
				</div>

				<div class="form-group mt-5">
					<button (click)="save()" class="btn btn-success">
						<span>Wijzigingen opslaan</span>
					</button>
				</div>
			</div>
			<div class="col-lg-4 d-none d-lg-block" *ngIf="currentTab!='portfolio'">

				<h5>Privacy</h5>
				<p>Wil je weten hoe wij omgaan met je persoonlijke gegevens? <a
					href="https://uitgeverijneo.nl/blog/privacy-by-design-hoe-neo-omgaat-met-persoonsgegevens" target="_blank">Lees hierover op onze blog</a>.</p>

				<h5>Account verwijderen</h5>
				<p>Alleen docenten kunnen accounts van leerlingen verwijderen.</p>

				<h5>Wat is een goed wachtwoord?</h5>
				<p>Gebruik niet hetzelfde wachtwoord voor alles. Als een hacker jouw school e-mailadres hackt, wil je niet dat hij ook bij je privé e-mail of Netflix-account kan.</p>
			</div>
		</div>
	</div>
</section>
<iframe id="portfolioPDFObject" style="display:none;"></iframe>